var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeIconGreen2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2709_26810)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000488281 4.12509C-0.000488281 2.26115 1.51053 0.750122 3.37447 0.750122L11.4424 0.750122C12.3375 0.750122 13.1959 1.1057 13.8289 1.73863L17.0108 4.92058C17.6436 5.55351 17.9993 6.41195 17.9993 7.30704L17.9993 19.8749C17.9993 21.739 16.4884 23.2499 14.6243 23.2499L3.37447 23.2499C1.51053 23.2499 -0.000488281 21.739 -0.000488281 19.8749L-0.000488281 4.12509ZM3.37447 3.0001C2.75316 3.0001 2.24948 3.50378 2.24948 4.12509L2.24948 19.8749C2.24948 20.4962 2.75316 20.9999 3.37447 20.9999L14.6243 20.9999C15.2456 20.9999 15.7493 20.4962 15.7493 19.8749L15.7493 7.30704C15.7493 7.00868 15.6307 6.72253 15.4198 6.51155L12.2379 3.3296C12.0269 3.11863 11.7408 3.0001 11.4424 3.0001L3.37447 3.0001Z",
    fill: "#008062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3745 3.00012C2.75319 3.00012 2.24951 3.5038 2.24951 4.12511L2.24951 19.875C2.24951 20.4963 2.75319 21 3.3745 21L14.6244 21C15.2457 21 15.7493 20.4963 15.7493 19.875L15.7493 7.30706C15.7493 7.0087 15.6307 6.72255 15.4198 6.51157L12.2379 3.32962C12.0269 3.11865 11.7408 3.00012 11.4424 3.00012L3.3745 3.00012Z",
    fill: "#008062"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25535 12.7441C5.92991 12.4186 5.40228 12.4186 5.07684 12.7441C4.7514 13.0695 4.7514 13.5972 5.07684 13.9226L6.15425 15L5.07684 16.0774C4.7514 16.4028 4.7514 16.9305 5.07684 17.2558C5.40228 17.5813 5.92991 17.5813 6.25535 17.2558L7.92198 15.5892C8.2474 15.2638 8.2474 14.7361 7.92198 14.4107L6.25535 12.7441ZM9.83271 15.8334C9.37246 15.8334 8.99938 16.2064 8.99938 16.6666C8.99938 17.1268 9.37246 17.5 9.83271 17.5L12.3327 17.5C12.7929 17.5 13.166 17.1268 13.166 16.6666C13.166 16.2064 12.7929 15.8334 12.3327 15.8334L9.83271 15.8334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2709_26810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9998,
    height: 22.4998,
    fill: "white",
    transform: "translate(-0.000488281 0.750122)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeIconGreen2);
export default __webpack_public_path__ + "static/media/CodeIconGreen2.4cd1901c379eaab0e7c56eda7e5e8981.svg";
export { ForwardRef as ReactComponent };